"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        designerv2.BASE_COMPONENT_TYPE = {
            GROUP: 'group'
        };
        designerv2.PROPERTY_TYPE = {
            TEXT: 'text',
            TEXT_MULTI: 'textMulti',
            UI_TEXT: 'uiText',
            BOOL: 'bool',
            ENUM: 'enum',
            NUMERIC: 'numeric',
            COLOR: 'colorSelector',
            FONT_STYLE: 'fontStyle',
            LABEL_COPY: 'labelCopy',
            FILE_UPLOAD: 'fileUpload',
            GROUP: 'group'
        };
        designerv2.BASE_PROPERTIES = {
            label: { name: T('Title'), type: 'uiText', tooltip: T('The title text for this element'), defaultValue: { eng: 'Sample Title' }, sector: 'basic' },
            labelStyle: { name: T('Title Style'), type: 'fontStyle', tooltip: T('Style for the title text'), defaultValue: { color: '#333333', decor: 'Normal', size: 'Medium' }, sector: 'basic' },
            hint: { name: T('Hint'), type: 'uiText', tooltip: T('Hint text displayed below the title'), defaultValue: { eng: '' }, sector: 'basic' },
            hintStyle: { name: T('Hint Style'), type: 'fontStyle', tooltip: T('Style for the hint text'), defaultValue: { color: '#777777', decor: 'Italic', size: 'Small' }, sector: 'basic' }
        };
        designerv2.EVENTS = {
            STATE_CHANGED: 'state:changed',
            COMPONENT_SELECTED: 'component:selected',
            PROPERTY_UPDATED: 'property:updated',
            DATA_REFRESH_REQUESTED: 'data:refresh_requested',
            DATA_FETCH_SUCCESS: 'data:fetch_success',
            ERROR_OCCURRED: 'error.occurred'
        };
        let FormulaType;
        (function (FormulaType) {
            FormulaType["fieldsOnly"] = "fieldsOnly";
            FormulaType["template"] = "template";
            FormulaType["uiText"] = "uitext";
            FormulaType["normal"] = "text";
        })(FormulaType = designerv2.FormulaType || (designerv2.FormulaType = {}));
        let FormulaMode;
        (function (FormulaMode) {
            FormulaMode["xml"] = "xml";
            FormulaMode["json"] = "json";
            FormulaMode["url"] = "url";
            FormulaMode["email"] = "email";
        })(FormulaMode = designerv2.FormulaMode || (designerv2.FormulaMode = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
